import { Box, Paper, Skeleton } from '@mantine/core'

import { ProxiedImage } from 'src/components/ProxiedImage'

type Props = {
  src?: string
  alt?: string
  isPending: boolean
  imageWidth?: number
}

export const ArticleHeroImage = ({
  src,
  alt,
  isPending,
  imageWidth = 1200
}: Props) => (
  <Paper
    radius="xl"
    className="overflow-hidden"
    pos="relative"
    w="100%"
    style={{ height: 'min(70vh, 680px)', minHeight: 320 }}
  >
    {isPending ? (
      <Skeleton
        pos="absolute"
        style={{ inset: 0, zIndex: 1 }}
        h="100%"
        radius={0}
      />
    ) : (
      <>
        <Box pos="absolute" style={{ inset: 0 }} bg="gray.2" />
        <ProxiedImage
          src={src}
          transform={{ w: imageWidth }}
          alt={alt}
          pos="absolute"
          w="100%"
          h="100%"
          fit="cover"
          style={{ inset: 0 }}
        />
      </>
    )}
  </Paper>
)
